/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".chargingProjectHeader[_ngcontent-%COMP%]{font-size:1.5rem}.listHeaderText[_ngcontent-%COMP%]{font-size:.875rem;font-weight:700;color:#696969}.listContentText[_ngcontent-%COMP%]{font-size:.875rem;color:#696969}.inProcessOption[_ngcontent-%COMP%]{text-align:center;padding-top:.625rem;cursor:pointer}.inProcessOption[_ngcontent-%COMP%]:hover{background-color:#f3fbfd}"];
export { styles as styles };
